import { minPageSizeConfigs } from "./Utils"

export const STATUS_COLORS = [
    '#20c997',
     '#ffb547',
     '#f56c7a',
     '#6c8cff',
     '#9b8cff',
     '#5bc0de'
]

export const TYPE_COLORS = [
    '#6c8cff',
     '#4fd1c5',
     '#f6ad55',
     '#b794f4',
     '#63b3ed',
     '#fc8181'
]

export const EMPTY_FORM_QRIS_CONFIGS = {
  name: '',
  payment_vendors_id: '',
  client_id: '',
  mpan: '',
  nmid: '',
  terminal_id: '',
  sub_merchant_id: '',
  partner_merchant_type: '',
  terminal_location_name: '',
  postal_code: '',
  description: '',
  enabled: false
}

export const EMPTY_FORM_IPWHITELISTING = {
  deviceName: '',
  ip: ''
}

export const EMPTY_FORM_INQUIRY_CONFIG = {
  id: null,
  name: '',
  payment_vendors_id: '',
  prefix: '',
  callback_url: '',
  description: '',
  enabled: true
}


export const DEFAULT_INQUIRY_CALLBACK_FILTERS = {
  trxId: '',
  deviceName: '%',
  inquiryType: '%',
  status: '%',
  from: '',
  to: '',
  userId: 'ALL',
  pageSize: minPageSizeConfigs
}

export const DEFAULT_GLOBAL_CALLBACK_TYPES = [
  'QRIS',
  'DOKU',
  'BCA',
  'BNI'
]

export const DEFAULT_GLOBAL_CALLBACK_FILTERS = {
  type: '%',
  paymentVendorsId: '',
  qrisExtConfigsId: '',
  endpoint: '%',
  status: '%',
  from: '',
  to: '',
  userId: 'ALL',
  pageSize: minPageSizeConfigs
}

export const EMPTY_BANK_ROUTER_FILTERS = {
  name: '',
  bank_channel: '',
  payment_vendors_id: '',
  enabled: ''
}

export const EMPTY_BANK_ROUTE_FORM = {
  name: '',
  patner_service_id: '',
  prefix_cust_no: '',
  payment_vendors_id: '',
  bank_channel: 'BNI',
  enabled: false
}

export const EMPTY_API_CALLBACK_FORM = {
  device_name: '',
  endpoint: '',
  token: '',
  is_global_callback: false
}

export const EMPTY_ADD_USER_FORM = {
  username: '',
  email: '',
  password: ''
}

export const EMPTY_QRIS_EXTCONF_FORM = {
  name: '',
  payment_vendors_id: '',
  prefix: '',
  callback_url: '',
  description: '',
  enabled: false
}


export const ENV_PAYMENT_VENDOR_OPTIONS = [
  'DOKU',
  'BCA-SNAP',
  'BNI-SNAP'
]

export const paymentVendorStatusType = [
  'all', // both
  'inbound', // callback
  'outbound' // send request
]

export function paymentVendorStatusExplanation (status) {
  if(status === paymentVendorStatusType[0]) {
    // All
    return 'Credentials untuk Menerima Callback dan Request VA/QRIS'
  }

  if(status === paymentVendorStatusType[1]) {
    // Inbound
    return 'Credentials untuk Request generate VA/QRIS ke vendor'
  }

  if(status === paymentVendorStatusType[2]) {
    // Outbound
    return 'Credentials untuk Menerima Callback pembayaran'
  }

  return ''
}


export const EMPTY_PAYMENT_VENDOR_FORM = {
  name: '',
  enviroment_type: ENV_PAYMENT_VENDOR_OPTIONS[0],
  connection_type: paymentVendorStatusType[0],
  description: '',
  enabled: false,
  is_production: false,
  is_payment_support: false,
  client_id: '',
  client_key: '',
  server_key: '',
  api_key: '',
  secret_key: '',
  auth_code: '',
  doku_public_key: '',
  merchant_public_key: '',
  public_key: '',
  private_key: '',
  krmdoku_account_no: '',
  krmdoku_fee_type: '',
  krmdoku_channel_code: '',
  krmdoku_type_personal_id: ''
}
